import { render, staticRenderFns } from "./PlusHeader.vue?vue&type=template&id=7807eea4"
import script from "./PlusHeader.vue?vue&type=script&lang=js"
export * from "./PlusHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports